import React, { useState, useEffect, Fragment } from 'react';
import {
  Grid,
  Segment,
  Breadcrumb,
  Form,
  Label,
  Icon,
  Button,
  List,
  Table,
} from 'semantic-ui-react';
import { withRouter, Link, Redirect, useHistory } from 'react-router-dom';
import _ from 'lodash';
import { Formik, setNestedObjectValues } from 'formik';
import * as Yup from 'yup';
import { ProjectInnerForm } from './ProjectInnerForm';

const ProjectsModif = ({ match }) => {
  const idProject = match.params.id;
  const history = useHistory()

  // Hooks to local state
  const [project, setProject] = useState('');

  // Effect hook
  useEffect(() => {

    try {
      fetch(
        'https://map.geomatick.com/geoserver/wfs?service=WFS&version=1.1.0&request=GetFeature&typename=raidisputa:projects&outputFormat=application/json&featureID=' +
          idProject +
          '',
        {
          headers: {
            Authorization: 'Basic ' + btoa('raidisputags:3VC8cNt7p6xUiuR76'),
          },
        }
      ).then(async (response) => {
        const data = await response.json();
        setProject(data.features[0].properties);
        
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    status: Yup.string().required(),
  });

  return (
    <Grid>
    <Grid.Row>
      <Grid.Column width={16}>
        <Breadcrumb>
          <Breadcrumb.Section as={Link} to='/cases'>
            Cases
          </Breadcrumb.Section>
          <Breadcrumb.Divider />
          <Breadcrumb.Section active>Update</Breadcrumb.Section>
          <Breadcrumb.Divider />
          <Breadcrumb.Section as={Link} to={`/cases/${idProject}`}>
            {_.capitalize(project.name)}
          </Breadcrumb.Section>
        </Breadcrumb>
      </Grid.Column>
    </Grid.Row>

    <Grid.Row>
      <Grid.Column width={16}>
        <Segment.Group>
          <Segment attached='top'>
            <h5>Case description</h5>
          </Segment>
          <Segment attached='bottom'>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Formik
                    enableReinitialize //Important
                    // Initializing values in Formik is mandatory
                    initialValues={{
                      name: `${project.name}`,
                      status: `${project.status}`,
                      municipality: `${project.municipality}`,
                      postu: `${project.postu}`,
                      areatype: `${project.areatype}`,
                      landtype: `${project.landtype}`,
                      landlocation: `${project.landlocation}`,
                      // sacredplaces: false,
                      cultural_evidence: `${project.cultural_evidence}`,
                      watersprings: project.watersprings ,
                      commodities: `${project.commodities}`,
                      // clanlinearity: '',
                      yearstart: `${project.yearstart}`,
                      yearclaiming: `${project.yearclaiming}`,
                      actors: `${project.actors}`,
                      secondaryactors: `${project.secondaryactors}`,
                      legalstatusfarmerspov: `${project.legalstatusfarmerspov}`,
                      ownershipprooffarmerspov: `${project.ownershipprooffarmerspov}`,
                      juridicsituationclaming: `${project.juridicsituationclaming}`,
                      legalstatusotherpov: `${project.legalstatusotherpov}`,
                      ownershipproffotherpov: `${project.ownershipproffotherpov}`,
                      juridicsituationotherpov: `${project.juridicsituationotherpov}`,
                      conflicthistory: `${project.conflicthistory}`,
                      conflictarea: `${project.conflictarea}`,
                      impactedhouseholds: `${project.impactedhouseholds}`,
                      impactedmen: `${project.impactedmen}`,
                      impactedwomen: `${project.impactedwomen}`,
                      // impactedkids: 0,
                      impactedyouth: `${project.impactedyouth}`,
                      impacteddisabled: `${project.impacteddisabled}`,
                      futureplans: `${project.futureplans}`,
                      // govrespectslaw: false,
                      plannedcompensation: `${project.plannedcompensation}`,
                      ksisupportstart: `${project.ksisupportstart}`,
                      ksisupporttype: `${project.ksisupporttype}`,
                      supportuseland: `${project.supportuseland}`,
                      additionalinformation: `${project.additionalinformation}`
                    }}
                    // Handle form validation
                    validationSchema={validationSchema}
                    // Handle form submit
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      //
                      setSubmitting(true);

                      let wfstransaction = '<wfs:Transaction service="WFS" version="1.0.0" '+
                        'xmlns:raidisputa="https://map.geomatick.com/raidisputa" '+
                        'xmlns:ogc="http://www.opengis.net/ogc" '+
                        'xmlns:wfs="http://www.opengis.net/wfs">'+
                        '<wfs:Update typeName="raidisputa:projects">'+
                        '<wfs:Property><wfs:Name>name</wfs:Name><wfs:Value>'+values.name+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>status</wfs:Name><wfs:Value>'+values.status+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>municipality</wfs:Name><wfs:Value>'+values.municipality+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>postu</wfs:Name><wfs:Value>'+values.postu+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>areatype</wfs:Name><wfs:Value>'+values.areatype+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>landtype</wfs:Name><wfs:Value>'+values.landtype+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>landlocation</wfs:Name><wfs:Value>'+values.landlocation+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>cultural_evidence</wfs:Name><wfs:Value>'+values.cultural_evidence+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>watersprings</wfs:Name><wfs:Value>'+values.watersprings+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>commodities</wfs:Name><wfs:Value>'+values.commodities+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>yearstart</wfs:Name><wfs:Value>'+values.yearstart+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>yearclaiming</wfs:Name><wfs:Value>'+values.yearclaiming+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>actors</wfs:Name><wfs:Value>'+values.actors+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>secondaryactors</wfs:Name><wfs:Value>'+values.secondaryactors+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>legalstatusfarmerspov</wfs:Name><wfs:Value>'+values.legalstatusfarmerspov+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>ownershipprooffarmerspov</wfs:Name><wfs:Value>'+values.ownershipprooffarmerspov+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>juridicsituationclaming</wfs:Name><wfs:Value>'+values.juridicsituationclaming+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>legalstatusotherpov</wfs:Name><wfs:Value>'+values.legalstatusotherpov+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>ownershipproffotherpov</wfs:Name><wfs:Value>'+values.ownershipproffotherpov+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>juridicsituationotherpov</wfs:Name><wfs:Value>'+values.juridicsituationotherpov+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>conflicthistory</wfs:Name><wfs:Value>'+values.conflicthistory+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>conflictarea</wfs:Name><wfs:Value>'+values.conflictarea+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>impactedhouseholds</wfs:Name><wfs:Value>'+values.impactedhouseholds+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>impactedmen</wfs:Name><wfs:Value>'+values.impactedmen+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>impactedwomen</wfs:Name><wfs:Value>'+values.impactedwomen+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>impactedyouth</wfs:Name><wfs:Value>'+values.impactedyouth+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>impacteddisabled</wfs:Name><wfs:Value>'+values.impacteddisabled+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>futureplans</wfs:Name><wfs:Value>'+values.futureplans+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>plannedcompensation</wfs:Name><wfs:Value>'+values.plannedcompensation+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>ksisupportstart</wfs:Name><wfs:Value>'+values.ksisupportstart+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>ksisupporttype</wfs:Name><wfs:Value>'+values.ksisupporttype+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>supportuseland</wfs:Name><wfs:Value>'+values.supportuseland+'</wfs:Value></wfs:Property>'+
                        '<wfs:Property><wfs:Name>additionalinformation</wfs:Name><wfs:Value>'+values.additionalinformation+'</wfs:Value>'+
                        '</wfs:Property>'+
                          '<ogc:Filter>'+
                            '<ogc:FeatureId fid="'+idProject+'"/>'+
                          '</ogc:Filter>'+
                        '</wfs:Update>'+
                      '</wfs:Transaction>';

                      //console.log(wfstransaction);

                      fetch('https://map.geomatick.com/geoserver/raidisputa/wfs', {
                        method: 'POST',
                        headers: {
                          Authorization: 'Basic ' + btoa('raidisputags:3VC8cNt7p6xUiuR76'),
                          'Content-Type': 'text/xml; charset=utf-8',
                        },
                        body: wfstransaction,
                      }).then( async (response) => {
                        await response
                          .text()
                          .then(function (text) {
                            //console.log(text)
                            return idProject;
                          })
                          .then((response) => {
                            if (response !== null) {
                              //console.log(response)
                              history.push(`/cases/${response}`)
                            }
                          });
                      });

                    }}
                  >
                    {({
                      // Desctructuring formik props
                      values,
                      errors,
                      dirty,
                      isValid,
                      handleSubmit,
                      isSubmitting,
                    }) => {
                      return (
                        <Form onSubmit={handleSubmit}>
                          <ProjectInnerForm values={values} />

                          <div>
                            <Button
                              primary
                              content='Confirm'
                              type='submit'
                              disabled={isSubmitting || !isValid || !dirty}
                              loading={isSubmitting}
                            />
                          </div>

                          {/* Uncomment following lines to debug form */}
                          {/*<pre>
                            values = {JSON.stringify(values, null, 2)}
                          </pre>
                          <pre>
                            errors = {JSON.stringify(errors, null, 2)}
                          </pre>*/}
                        </Form>
                      );
                    }}
                  </Formik>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </Segment.Group>
      </Grid.Column>
    </Grid.Row>
  </Grid>

  );
};

export default ProjectsModif;
